const stats = [
  { number: "10,000+", label: "Businesses Served" },
  { number: "$2B+", label: "Contracts Secured" },
  { number: "99%", label: "Client Satisfaction" },
  { number: "24/7", label: "Expert Support" },
];

const BizServePortalMission = () => {
  return (
    <section className="py-16 px-4 bg-hero-gradient">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Our Mission: Your Success
          </h2>
          <p className="text-lg text-white/90 max-w-3xl mx-auto">
            We believe every entrepreneur deserves access to the tools,
            guidance, and support needed to build a successful business. From
            startup to scale-up, we're here to help you thrive.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center text-white">
              <div className="text-4xl md:text-5xl font-bold mb-2">
                {stat.number}
              </div>
              <div className="text-white/90 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-4">
              Trusted by Entrepreneurs Nationwide
            </h3>
            <p className="text-white/90 text-lg">
              "BizServe transformed our business from a startup idea to a
              thriving government contractor. Their integrated approach saved us
              months of setup time and gave us the confidence to compete for
              federal contracts from day one."
            </p>
            <div className="mt-4 text-white/80">
              <strong>Sarah Chen</strong> - Founder, TechSolutions LLC
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BizServePortalMission;
